module.exports = __webpack_public_path__ + "static/media/login-image-desktop@3x.2fdda8bc.png";